<template>
    <div class="quill-editor-container">
        <el-row :gutter="15">
            <el-col :span="24">
                <div class="input-label">عنوان مطلب:</div>
                <el-input placeholder="عنوان مطلب" v-model="title"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :span="24">
                <div class="input-label">چکیده:</div>
                <el-input placeholder="چکیده" v-model="abstract"></el-input>
            </el-col>
        </el-row>

        <el-row :gutter="15">
            <el-col :span="24" class="quill-editor-col">
                <div class="input-label">متن:</div>
                <quill
                    ref="writingEditor"
                    class="quill-editor"
                    v-model="content"
                    :config="config">
                </quill>
            </el-col>
        </el-row>

        <el-row>
            <el-col>
                <el-button type="primary" size="medium" @click="saveWriting()">
                    <app-upload-icon/>
                    ذخیره مطلب
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        name: 'CreateWriting',
        props: {
            msg: String
        },
        data() {
            return {
                title: '',
                abstract: '',
                content: {
                    ops: [
                        {'attributes':{'italic':true,'bold':true,'color': '#BBBBBB'},'insert':'متن خود را اینجا وارد کنید.'},
                        {'attributes':{'align':'right','direction':'rtl'},'insert':'\n\n'}
                    ],
                },
                config: {
                    modules: {
                        toolbar: {
                            container: [
                                [{'font': []}],
                                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                                [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
                                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                                [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
                                [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                                ['blockquote', 'code-block'],
                                [{'header': 1}, {'header': 2}],               // custom button values
                                [{'list': 'ordered'}, {'list': 'bullet'}, {'indent': '-1'}, {'indent': '+1'}],
                                [{'direction': 'rtl'}, {'align': []}],                         // text direction
                                ['link', 'image', 'video', 'formula'],
                                ['clean']                                         // remove formatting button
                            ],
                            handlers: {
                                'image': this.imageHandler
                            }
                        },
                        ImageResize: {
                            modules: ['Resize', 'DisplaySize', 'Toolbar']
                        }
                    },
                    // placeholder: 'Compose an epic...',
                },
            }
        },
        computed: {
            getConfig() {
                return this.content;
            }
        },
        methods: {
            saveWriting() {
                console.log(this.content.ops);
                console.log(JSON.stringify(this.content.ops));
                this.$http.post(
                    `${this.apiURL}/writing/new`,
                    {
                        title: this.title,
                        abstract: this.abstract,
                        content: this.content
                    }
                ).then((response) => {
                    console.log(response);
                }).catch((error) => {
                    console.error(error.response.data);
                });
            },
            imageHandler() {
                this.openFilePicker();
            },
            openFilePicker() {
                let input = document.createElement('input');
                input.setAttribute('type', 'file');

                input.click();

                // Listen upload local image and save to server
                input.onchange = () => {
                    let file = input.files[0];
                    if (/^image\//.test(file.type)) {
                        this.sendFile(file);
                    }
                    else {
                        console.warn('You could only upload images.');
                    }
                };
            },
            sendFile(file) {
                let fd = new FormData();
                fd.append('image', file);

                this.$http.post('http://localhost:3000/writing/image', fd).then(
                    (response) => {
                        if (response.status === 201) {
                            let url = response.data.url;
                            this.insertToEditor(url);
                        }
                        else {
                            console.error(response);
                        }
                    }
                ).catch(
                    (error) => {
                        console.error(error);
                    }
                );
            },
            insertToEditor(url) {
                let quill = this.$refs.writingEditor.editor;
                let range = quill.getSelection();
                quill.insertEmbed(range.index, 'image', `http://localhost:3000/${url}`);
                quill.setSelection(range.index + 1);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .el-row {
        margin-bottom: 20px;

        .el-col {

            .input-label {
                font-size: 14px;
            }

            .el-input {
                direction: ltr;

                &::v-deep {
                    input {
                        direction: rtl;
                    }

                    .el-input-group__append {

                        svg {
                            vertical-align: text-top;
                        }
                    }
                }
            }

            .el-button {

                svg {
                    vertical-align: text-top;
                }
            }

            &.quill-editor-col {
                min-height: 200px;

                &::v-deep > .quill-editor {

                    .ql-container {
                        min-height: 100px;
                    }
                }
            }
        }
    }
</style>
